import React from 'react'
import store from '../../store'
import dispatcher from '../../dispatcher'
import _ from 'lodash'


export default class ConnectedComponent extends React.Component {

  constructor() {
    super()
    this.dispatcher = dispatcher
    this.store = store
    this._subs = {}
  }

  _subsupdater = () => {
    this.forceUpdate()
  }

  subscribe = (evt) => {
    if (!this._subs[evt]) {
      this._subs[evt] = true
    }
  }
  unsubscribe = (evt) => {
    dispatcher.removeListener(evt + ':changed', this._subsupdater)
    delete this._subs[evt]
  }

  componentWillMount() {
    _.each(this._subs, (item, key) => {
      dispatcher.on(key + ':changed', this._subsupdater)
    })
  }
  componentWillUnmount() {
    _.each(this._subs, (item, key) => {
      this.unsubscribe(key)
    })
  }

}


// WEBPACK FOOTER //
// ./src/shared/connecter/ConnectedComponent.jsx